import React, { Component } from 'react';
import { Grid, GridCell } from 'rmwc/Grid';
import { connect } from 'react-redux';
import { Typography } from 'rmwc/Typography';
import { Link } from 'react-router-dom'
import { Card } from 'rmwc/Card';
import {Button} from 'rmwc/Button';
import * as api from '../../api/api';
import { List, ListItem, ListItemText, ListItemGraphic} from 'rmwc/List';
import Iframe from 'react-iframe'
import ReactGA from 'react-ga';

class QuestionnaireComp extends Component{
    constructor(props) {
        super(props)
        this.state = {
            status: 'loading',
            errorMsg: '',
            data:{
                id: '',
                link:'',
                name: '',
                userId: ''
            }
        }
    }

  handleBackAction = (e) => {
    if (this.props.match.params.type === 'quiz') {
      this.props.history.push('/portal/app/user/samplequiz_user_home')
    }
    else if (this.props.match.params.type === 'survey'){
      this.props.history.push('/portal/app/user/survey_user_home')
    }
  }

	componentDidMount() {
    
      ReactGA.set({ userId: this.props.user.id });
      ReactGA.initialize('UA-139837993-1');
      ReactGA.pageview(`${this.props.match.params.type}/${this.state.data.name}`);

	    let data = Object.assign({}, this.state.data)
	   	    
      let id = this.props.match.params.id
      let url = `questionnaires/${id}`
      return api.getUserResponse(this.props.user.accessToken, url)
        .then((result) => {
          console.log(result.status)
          if(result.status ==='success'){
            console.log(result.data)
            data.id = result.data.id
            data.userId = result.data.user_id
            data.link = result.data.link
            data.name = result.data.name
            this.setState({data: data, status:'success'})  
          }
          else if (result.status ==='error') {
            this.setState({errorMsg: 'No Data. Please Contact Admin', status:'error'})   
          }
       }).catch((err) => {
            this.setState({ errorMsg: 'Error in fetching data. Please contact Admin', status:'exception'})
      })
	}


	render(){
		 
    let mainPageContent
    let handleBackAction = this.handleBackAction

    if(this.state.status === 'success'){
      let userId = this.state.data.userId
      let questUrl =  this.state.data.link+"?userId=" + userId
      mainPageContent = (
        <Grid>
          
          <GridCell span = "12" key={this.state.data.userId}>

               <Iframe url={questUrl}
                        position="relative"
                        width="100%"
                        id="myId"
                        className="myClassname"
                        height="1250px"
                        allowFullScreen
                        scrolling />
                </GridCell>
        </Grid>
      )
    }
    
    else{
      let mainPageContent = (
        <div>
           <Typography use="subtitle2">Error Loading the Contents. Please contact Admin</Typography>
        </div>
      )

    }

	 return (
	 		<div> 

	 			<Grid>
          <GridCell span = "12">
              <Card style={{padding: '0px'}}>
                  <Grid className="opportunity-list-item">
                      <GridCell span = "11">
                          <Typography use="headline5">{this.state.data.name}</Typography>
                      </GridCell>
                      <GridCell span = "1">
                        <Button raised style={{ width: '100%' }} onClick={((e) => handleBackAction(e))}>Back</Button>
                      </GridCell>
                  </Grid>
              </Card>
          </GridCell>
          <GridCell span = "12">
          <Typography use="subtitle2">Please wait while this page loads..</Typography>
          	
          	{mainPageContent}
          </GridCell>
      	</Grid>


	 		</div>

	 	)
	}

}


function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(QuestionnaireComp);


// WEBPACK FOOTER //
// ./src/views/questionnaire/QuestionnaireComp.jsx